'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTargetCrosshairsProgress, iconTargetCrosshairsProgressTag } from '@ni/nimble-components/dist/esm/icons/target-crosshairs-progress';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTargetCrosshairsProgress };
export { iconTargetCrosshairsProgressTag };
export const NimbleIconTargetCrosshairsProgress = wrap(IconTargetCrosshairsProgress);